module.exports = __webpack_public_path__ + "img/solution_subsystem_03@2x.d65cd085.png";